export default __webpack_public_path__ + "static/media/1_0104.66655b35.webp";